import React from 'react';

//React-router-dom
import {NavLink} from 'react-router-dom';

//Styles
import './Navigation.scss';

import logo from "../Img/Logo.jpg"

//Font awesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { faBars } from "@fortawesome/free-solid-svg-icons";

function Navigation(props){
    return(
        <nav>
            
            <div className="container">
                <div className="nav-items">
                <img  src={logo} alt="Logo"  width={100}height={100}/>
                    <div className="logo">
                   
                        {/* <h3 style={{fontFamily: "Lucida Console"}}>GOLD CONSTRUCTION LIMITED</h3>   */}
                    </div>

                    <div className="menu">
                        <ul>
                            <li><NavLink to="/" exact activeClassName="active">Home</NavLink></li>
                            <li><NavLink to="/about" exact activeClassName="active">About Us</NavLink></li>
                            <li><NavLink to="/portfolio" exact activeClassName="active">Portfolio</NavLink></li>
                            <li><NavLink to="/contact" exact activeClassName="active">Contact</NavLink></li>
                        </ul>
                    </div>

                    {/* <div className="language">
                        <FontAwesomeIcon className="globe" icon={faGlobe} />
                        <p>Slovensky</p>
                        <FontAwesomeIcon className="angleDown" icon={faAngleDown} />
                    </div> */}

                    {/* <div className="contact">
                        <NavLink to="/contact" activeClassName="activeRental">Contact Us</NavLink>
                    </div> */}
                    
                    <div className="mobile-menu-icon" onClick={()=>props.openMobileMenu()}>
                        <FontAwesomeIcon icon={faBars} />
                    </div>
                </div>
            </div>

        </nav>
    )
}

export default Navigation;